/**
 * verificationCode模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const verificationCode = {
  // 获取图片旋转验证码
  getImageRotateCode () {
    return axios.get('/api/verificationCode/GetImageRotateCode')
  },
  // 获取图形验证码
  getImageCode () {
    return axios.get('/api/verificationCode/GetImageCode')
  },
  // 校验验证码
  checkVerificationCode (params) {
    return axios.post('/api/verificationCode/checkVerificationCode', params)
  },
  // 获取手机验证码，发送短信
  sendPhoneCode (params) {
    return axios.post('/api/verificationCode/SendPhoneCode', params)
  },
  // 校验手机验证码
  checkPhoneCode (params) {
    return axios.post('/api/verificationCode/checkPhoneCode', params)
  }
}

export default verificationCode
